
import { Card, Col, List, Row } from 'antd'
import React from 'react'
const Feats = props => {
  return (
    <>
      <Row style={{ marginTop: '2em' }}>
        <List
          grid={{ gutter: 16 }}
          dataSource={props?.awards}
          renderItem={(item) => (
            <List.Item>
              <Card title={<div style={{ textAlign: 'center' }}>{item.title}</div>} style={{ borderRadius: '25%', border: '2px dotted black' }}>
                {item?.winners?.map(winner => (
                  <div key={`${winner.name}_${item.title}`}>
                    <Row>
                      <Col flex='auto' style={{ textAlign: 'center' }}>{winner.name}</Col>
                    </Row>
                    <Row>
                      <Col flex='auto' style={{ textAlign: 'center' }}>{winner.value}</Col>
                    </Row>
                  </div>
                ))}

              </Card>
            </List.Item>
          )}
        />
      </Row>

    </>
  )
}

export default Feats
